import { render } from "./NicheSwitch.vue?vue&type=template&id=627d39e3&scoped=true"
import script from "./NicheSwitch.vue?vue&type=script&lang=js"
export * from "./NicheSwitch.vue?vue&type=script&lang=js"

import "./NicheSwitch.vue?vue&type=style&index=0&id=627d39e3&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627d39e3"]])

export default __exports__